import React from "react";

function Footer() {
  return (
    <footer className="bg-blue-900 text-white text-center p-4 mt-6">
      <p>© {new Date().getFullYear()} Jyothi Seafood | Freshness You Can Taste</p>
    </footer>
  );
}

export default Footer;
